import { Card, CardContent, CardHeader, Typography, WysiwygEditorField } from '@forgeglobal/design-framework'
import React from 'react'

export const CampaignHighlights: React.FC = () => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" color="secondary">
            Company Highlights
          </Typography>
        }
      />
      <CardContent surface="light">
        <WysiwygEditorField name="company_description" />
      </CardContent>
    </Card>
  )
}
